import { Injectable } from '@angular/core';
import { PersonViewModel } from '../view-models/person.view-model';

@Injectable({
    providedIn: 'root'
})
export class CustomersService {
    public employees: PersonViewModel[] = [];

    constructor() { }

}
